import React from 'react';
import { SEO } from '../components/seo/SEO';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { IndustryPillars } from '../components/sections/IndustryPillars';
import styles from './IndustriesPage.module.css';

export const IndustriesPage: React.FC = () => {
    const { t } = useLanguage();
    const { hero } = t.industriesPage;

    return (
        <div className={styles.page}>
            <SEO
                title="Industries"
                description="Discover our AI and SAP solutions tailored for Automotive, Energy, Logistics, Fintech, and Manufacturing industries."
                canonical="/industries"
            />
            <section className={styles.hero}>
                <div className={styles.hero__container}>
                    <motion.h1
                        className={styles.hero__title}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.15 }}
                    >
                        {hero.title}
                    </motion.h1>
                    <motion.p
                        className={styles.hero__subtitle}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.15, delay: 0 }}
                    >
                        {hero.subtitle}
                    </motion.p>
                </div>
            </section>

            {/* Industry Pillars - Cards with bullet points */}
            <IndustryPillars />
        </div>
    );
};
